import CardSkeleton from "../cards/CardSkeleton";

export default function PostsSkeleton() {
  // Create an array of 6 items to render 6 skeleton cards
  const skeletonItems = Array.from({ length: 8 }, (_, i) => i);

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3 md:gap-4 lg:gap-6">
      {skeletonItems.map((item) => (
        <CardSkeleton key={item} />
      ))}
    </div>
  );
}
